// extracted by mini-css-extract-plugin
export default {"container":"Wizard_container__R2eDP","form":"Wizard_form__fxocE"};